import axios from 'axios';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getAsync } from '../../../../components/helper/axiosHelper';
import { PageHitCountApi } from '../../../../shared/Helper';
import { useLocation } from 'react-use';

const DownloadcenterDetail = () => {
  const [apiData, setApiData] = useState([]);
  const { id } = useParams();
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const getData = async () => {
    await getAsync('CMSDownloadCenter/GetCMSCMSDownloadCenterById', { id: id })
      .then((response) => {
        const result = response?.data;
        setApiData(result);
      })
      .catch((error) => {
       toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    getData();
    PageHitCountApi(pathname, 0);
  }, []);

  return (
    <>
      <div className="col-lg-12">
        <div className="header-wrapper" style={{ textAlign: 'center' }}>
          <h1>Download Center Detail</h1>
        </div>
        <div style={{ margin: '20px', padding: '20px' }} className="col-lg-10">
          {apiData?.map((item, index) => (
            <div key={index}>
              <div className="wrapper">
                <img
                  style={{
                    borderRadius: '20px',
                    border: '1px solid black',
                    height: '500px',
                    width: '600px',
                  }}
                  src={`data:image/jpeg;base64,${item?.doc}`}
                  alt="img.jpg"
                />
              </div>
              <div className="content-title">
                <h2>{item?.titleEn}</h2>
                <a className="text-red-500" target="_blank" href={item?.link}>
                  {item?.link}
                </a>
                <p>{item?.date}</p>
              </div>
              <div className="content">
                <pre>{item?.newsPlace ? item?.newsPlace : 'N/A'}</pre>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default DownloadcenterDetail;
